import React from 'react';
import transparency from '../../assets/images/transparency.png';
import collaboration from  '../../assets/images/collaboration.png';
import support from '../../assets/images/support.png';

const SpiritOfTribe = () => {
  return ( 
    <div className="spirit-of-tribe">
      <p className="font-weight-extrabold text-black">THE SPIRIT OF THE TRIBE</p>
      <p className="text-primary fs-85 font-weight-thin">Farther. Together.</p>
      <p className="text-gray fs-14">Prizing teamwork above all else, we work with compassion, empathy, and patience. With<br></br> constant innovation and growth, we never lose sight of our goal - to make the world a<br></br> safer place by delivering smarter solutions.</p>
      <div className="row mt-5">
        <div className="col-md-4 mt-10">
          <img src={transparency} alt="Transparency" />
          <p className="font-weight-extrabold fs-20 pt-4">Transparency</p>
          <p className="fs-14 text-gray">Our open-door policy<br></br> welcomes dialogue across all<br></br> levels. You matter to us.</p>
        </div>
        <div className="col-md-4 mt-10">
          <img src={collaboration} alt="Collaboration" />
          <p className="font-weight-extrabold fs-20 pt-4">Collaboration</p>
          <p className="fs-14 text-gray">A tribe that works together, does<br></br> wonders together. Period.</p>
        </div>
        <div className="col-md-4 mt-10">
          <img src={support} alt="Support" />
          <p className="font-weight-extrabold fs-20 pt-4">Support</p>
          <p className="fs-14 text-gray">Constant support nurtures your<br></br> growth, and ultimately, success.</p>
        </div>
      </div>
    </div>
   );
}
 
export default SpiritOfTribe;